import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { AppBar, Box, IconButton, Toolbar, Tooltip, Typography, Breadcrumbs } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountProgress from './AccountProgress';
import MessageButton from './messageWidget';

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
	backgroundColor: theme.palette.background.paper,
	boxShadow: theme.shadows[3],
}));

export const DashboardNavbar = (props) => {
	const { onSidebarOpen, head, icon, title, subtitle, ...other } = props;

	//let way = title;

	return (
		<>
			<DashboardNavbarRoot
				sx={{
					left: {
						lg: 280,
					},
					width: {
						lg: 'calc(100% - 280px)',
					},
				}}
				{...other}
			>
				<Toolbar
					disableGutters
					sx={{
						minHeight: 50,
						left: 0,
						px: 2,
					}}
				>
					<IconButton
						onClick={onSidebarOpen}
						sx={{
							display: {
								xs: 'inline-flex',
								lg: 'none',
								cursor: 'pointer',
							},
							border: '1px solid #e9e6e6',
							borderRadius: 0,
							marginRight: '10px',
						}}
					>
						<MenuIcon fontSize="small" />
					</IconButton>
					<Breadcrumbs sx={{ display: 'flex', alignItems: 'center', fontSize: '15px' }} aria-label="breadcrumb">
						<Typography sx={{ fontSize: '15px', display: 'flex', alignItems: 'center' }} color="text.primary">
							{icon}
							<Typography sx={{ fontSize: '15px', display: 'inline', marginLeft: '10px' }} color="text.primary">
								{title}
							</Typography>
						</Typography>
						{subtitle ? (
							<Typography sx={{ fontSize: '15px', display: 'flex', alignItems: 'center' }} color="text.primary">
								<Typography sx={{ fontSize: '15px', display: 'inline' }} color="text.primary">
									{subtitle}
								</Typography>
							</Typography>
						) : (
							''
						)}
					</Breadcrumbs>

					<Box sx={{ flexGrow: 1 }} />
					{/* <Tooltip title="Contacts">
						<IconButton sx={{ ml: 1 }}></IconButton>
					</Tooltip> */}

					{/* <Tooltip title="Notifications">
						<IconButton sx={{ ml: 1 }}>
							<Badge badgeContent={4} color="primary" variant="dot"></Badge>
						</IconButton>
					</Tooltip> */}
					{/* <Link href="/settings/account"> */}
					{/*TODO NIGHT */}
					{/* <NightMode /> */}
					{head}
					{/* <AccountProgress></AccountProgress> */}
					{/* </Link> */}
				</Toolbar>
			</DashboardNavbarRoot>
			<MessageButton/>
		</>
	);
};

DashboardNavbar.propTypes = {
	onSidebarOpen: PropTypes.func,
};
